import Form from "./form/create_form.store";
import Edit from "./edit/edit.store";
import List from "./list/list.store";
import Delete from "./delete/delete.store";

export default {
  modules: {
    Delete,
    Form,
    List,
    Edit,
  },
};
